import isNonEmptyString from './isNonEmptyString';

const ALLOWED_PROTOCOLS = ['http:', 'https:', 'mailto:'];

function isSafeUrl(value) {
    if (!isNonEmptyString(value)) {
        return false;
    }

    try {
        const { protocol } = new URL(value, window.location.origin);

        return ALLOWED_PROTOCOLS.includes(protocol);
    } catch {
        return false;
    }
}

export default isSafeUrl;
